"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const stream_1 = require("stream");
/**
 * A wrapper around an RDF source that emits totalItems metadata *before* the end event.
 */
class RdfSourceMetadata {
    constructor(source) {
        this.source = source;
    }
    match(subject, predicate, object, graph) {
        const streamOut = new stream_1.Readable({ objectMode: true });
        streamOut._read = () => {
            streamOut._read = () => { return; };
            const streamIn = this.source.match(subject, predicate, object, graph);
            let totalItems = 0;
            streamIn.on('error', (error) => {
                streamOut.emit('error', error);
            });
            streamIn.on('data', (quad) => {
                totalItems++;
                streamOut.push(quad);
            });
            streamIn.on('end', () => {
                streamOut.emit('metadata', { totalItems });
                streamOut.push(null);
            });
        };
        return streamOut;
    }
}
exports.RdfSourceMetadata = RdfSourceMetadata;
//# sourceMappingURL=RdfSourceMetadata.js.map